export default __webpack_public_path__ + "media/images/banners/bnr_saga-0c689d5e901833e5fb9ca756e3f0bdbb.jpg";